
export const Footer = () => {
  return (
    <div className="footer mb-3">travelPaddi &copy; { new Date().getFullYear()}</div>
  )
}
